"use client"

import { useState } from "react"
import { ChevronDown } from "lucide-react"
import "./grades.css"

const GradesFour= () => {
  const [activePhase, setActivePhase] = useState(1)
  const [showDetails, setShowDetails] = useState(false)
  const [activeTab, setActiveTab] = useState(0)

  const phases = [
    {
      id: 1,
      number: 1,
      title: "مرحلة الذات",
      description:"ورشتا عمل تستهدفان فهم المشارك لدوافع سلوكه وقيمه وأهدافه. وتعززان الممارسة الأخلاقية للأعمال، وسمات الشخصية المؤثرة في ثقافة وسلوك العاملين.",
      
      details: [
        {
          tab: "الأنمــاط والأخــلاقيات ",
          content: [
          "أنماط الشخصية وأساليب القيادة",
          "معايير الأخلاق والقيادة الأخلاقية",
          "المواجهة وإدارة المحادثات",

          ]
        },
        {
          tab: " القيــم والصــفات ",
          content: [
        "مواءمة القيم الشخصية والتنظيمية",
        "التعاطف وبناء الثقة",
        "القدوة والالتزام",
 
           ]
        },
       
      ],
    },
    {
      id: 2,
      number: 2,
      title: "مرحلة الاستراتيجية",
      description:
        "ثلاث ورش عمل تناقش مفاهيم الرؤية والاستراتيجية، إدارة المخاطر، والتغيير بناء على فهم دوافع وأهداف المنظمة وأفرادها. وتتناول كيفية تأسيس ثقافة المشاركة ودعم الإبداع وإلهام العاملين.",
      details: [
        {
          tab: " التخــطيط والمســتقبل",
          content: [
           "التفكير والنماذج الاستراتيجية",
           "رصد التوجهات وتخطيط السيناريوهات",
           "التخطيط والقيادة",
   
             ]
        },
        {
          tab: "التغــيير والمخــاطر",
          content: [
          "نماذج التغيير والإدارة العاطفية للتغيير",
          "فهم وقياس المخاطر التنظيمية",
          "إدارة المخاطر"
   
             ]
        },
        {
            tab: "الريادة والابتكار",
            content: [
            "إدارة الإبداع التنظيمي",
            "المشاركة وإدارة الابتكار",
            "الريادة التنظيمية وإدارة النمو"
     
               ]
          },
      
      ],
    },
    {
      id: 3,
      number: 3,
      title: "مرحلة التكوين   ",
      description:
        "أربع ورش عمل تتناول بناء وتطوير كوادر قادرة، في بيئة عمل صحية ومتوازنة. وتناقش تقنيات تعزيز الأداء ورفع الكفاءة، وتوفير الدعم والتوجيه للعاملين.",
      details: [
        {
          tab: "بيئــة العمــل ",
          content: [
          "العافية والصحة والسلامة",
          "التوازن المهني الشخصي",
          "بيئة العمل المتوازنة",
     
               ]
        },
        {
          tab: "إدارة الأداء",
          content: [
          "عمليات التوظيف والخروج",
          "تقييم وعلاج فجوات الأداء",
          "تعظيم المخرجات",
      
                ]
        },
        {
          tab: "إدارة الأفــراد",
          content: [
           "الإرشاد والتوجيه",
           "القيادة التكيفية",
           "القيادة الرشيقة",
                 ]
        },
        {
            tab: "التطــوير والنمــو",
            content: [
           "إدارة الأزمات وعقلية النمو",
           "رصد وتطوير المواهب",
           "خطط التطوير الفردي وتخطيط التعاقب"
                   ]
          },
      ],
    },
    {
      id: 4,
      number: 4,
      title: "مرحلة القدرة",
      description: "ثلاث ورش عمل تركز على بناء القدرة القيادية، من خلال تطوير آلية صناعة القرار ومنهجية التفكير والتحليل. وكذلك تفعيل استراتيجيات التعلم المستمر والتفويض لتمكين الكوادر.",
      details: [
        {
          tab: " صــناعة القــرار",
          content: [
            'تحليل التكلفة والعائد ',
            'الحدس وعلاج المشكلات',
            'الإدارة التصاعدية'
       
                 ]
        },
        {
          tab: "التعــلم والتمــكين",
          content: [
          'ثقافة اللوم والتعلم التجريبي',
          'التفويض والتفاعل',
          'التركيز والأولويات',
       
                 ]
        },
        {
          tab: "التفــكير والمســؤولية",
          content: [
          'نموذج العمل التجاري',
          'المبادرة الواثقة ورصد الفرص',
          'التفكير النقدي والتفكير التأملي',
       
                 ]
        },
      ],
    },
    {
      id: 5,
      number: 5,
      title: "مرحلة الفعالية ",
      description: "أربع ورش عمل تعزز العمل الجماعي وتنمي مهارات بناء علاقات العمل داخل المنظمة ومع الأطراف الخارجية، وتصقل ممارسات التخطيط والإدارة التشغيلية.",
      details: [
        {
          tab: "الفــرق والمجــموعات",
            content: [
            'إدارة النماذج السلوكية لفرق العمل',
            'التفاوض والوساطة وإظهار الحسم',
            'الاحترام والتحيز غير الواعية',
            ],
        },
        {
          tab: "التواصــل والعلاقــات",
          content: [
       'التشبيك وإدارة أصحاب المصلحة',
       'التواصل الرسمي وغير الرسمي',
       'عرض الأفكار والحلول وإدارة الاجتماعات',
         ],
        },
        {
          tab: "البــرامج والعمــلاء",
          content: [
         'قيادة المشروعات وإدارة البرامج',
         'إشراك أصحاب المصلحة',
         'إدارة علاقات العملاء',
             ],
        },
        {
            tab: "التنــوع والنــزاع",
            content: [
           'الذكاء الثقافي والعمل عبر الثقافات',
           'الحساسية الاجتماعية',
           'إدارة النزاع وبلوغ المكاسب المشتركة'
               ],
          },
      ],
    },
  ]

  const handlePhaseClick = (phaseId) => {
    setActivePhase(phaseId)
    setShowDetails(false)
  }

  const toggleDetails = () => {
    setShowDetails(!showDetails)
    setActiveTab(0)
  }

  const handleTabClick = (index) => {
    setActiveTab(index)
  }

  const activePhaseData = phases.find((phase) => phase.id === activePhase)

  return (
    <div className="program-design-container">
      <div className="program-header-g">
        <h2 className="program-title">فلسفة تصميم البرنامج</h2>
        <div className="program-subtitle">
        يمتد البرنامج اثني عشر شهرا، يمر فيها المشارك بخمس مراحل، تتضمن ثلاثة عشر ورشة عمل منفصلة متصلة.


</div>
      </div>

      <div className="program-content">
        <div className="phases-details">
          <h3 className="details-title">تفاصيل المرحلة</h3>
          <div className="details-content">{activePhaseData.description}</div>

          <button className="details-toggle" onClick={toggleDetails}>
            <span>تفاصيل المرحلة</span>
            <ChevronDown className={`details-icon ${showDetails ? "rotated" : ""}`} />
          </button>

          {showDetails && (
  <div className="details-tabs">
    <div className="tabs-header">
      {activePhaseData.details.map((detail, index) => (
        <button
          key={index}
          className={`tab-button ${activeTab === index ? "active" : ""}`}
          onClick={() => handleTabClick(index)}
        >
          {detail.tab}
        </button>
      ))}
    </div>
    <div className="tab-content">
      <ul>
        {activePhaseData.details[activeTab].content.map((item, index) => (
          <li key={index}><i class="far fa-check-circle"></i>{item}</li>
        ))}
      </ul>
    </div>
  </div>
)}

        </div>

        <div className="phases-list">
          {phases.map((phase) => (
            <div
              key={phase.id}
              className={`phase-item ${activePhase === phase.id ? "active" : ""}`}
              onClick={() => handlePhaseClick(phase.id)}
            >
              <div className="phase-number">{phase.number}</div>
              <div className="phase-title">{phase.title}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default GradesFour
